// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for locks
export const lockState = $state({
    video: true,
    caption: false,
    preview: true
});